"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DefaultHubRetryPolicy {
    // eslint-disable-next-line class-methods-use-this
    nextRetryDelayInMilliseconds(retryContext) {
        return Math.round((Math.log(retryContext.previousRetryCount + 1)) * 1000);
    }
}
exports.default = DefaultHubRetryPolicy;
